import React, { useEffect, useRef, useState } from 'react';
import './style.scss'; // We'll define the styles below
import Modal from '../../../../Shared/Components/Modal';

const MapPicker = ({ onContinue, coordinates }) => {
  const mapRef = useRef("");
  const [address, setAddress] = useState('');
  const [latLng, setLatLng] = useState({ lat: 0, lng: 0 });
  const [completeAddress, setCompleteAddress] = useState({})
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  useEffect(() => {
    const mapEl = mapRef.current ?? {};

    const handleLocationChanged = (e) => {
      const { address, lat, lng, city = undefined, country = undefined } = e.detail;
      setAddress(address);
      setLatLng({ lat, lng });
      setCompleteAddress({ address, lat, lng, city, country })
    };

    mapEl.addEventListener('location-changed', handleLocationChanged);

    return () => {
      mapEl.removeEventListener('location-changed', handleLocationChanged);
    };
  }, []);

  const openConfirmationPopup = () => {
    setShowConfirmationModal(true);
  }

  return (
    <div className="map-wrapper">
      <div className="map-content">
        <div className='map-head'>
          <p><strong>Confirm installation address</strong></p>
          <p>Accurate details will ensure faster activation</p>
        </div>

        <div className="map-container">
          <google-map
            ref={mapRef}
            apiKey={process.env.REACT_APP_GOOGLE_KEY}
            lat={coordinates?.lat || process.env.REACT_APP_LAT}
            lng={coordinates?.lng || process.env.REACT_APP_LNG}
            zoom={12}
            markerIcn={""}
          ></google-map>

          <div className="address-box">
            <input type="text" value={address} readOnly />
            <button onClick={openConfirmationPopup}>Continue</button>
          </div>
        </div>
        {showConfirmationModal && <Modal isOpen={showConfirmationModal}>
          <div className='confirmation-container'><h4>  Please confirm if the below address is correct</h4>
            <p className='address'>{address}</p>
            <div className='btn-wrap'>
              <button className='button edit' onClick={() => setShowConfirmationModal(false)}>edit</button>
              <button className='button' onClick={() => {
                setShowConfirmationModal(false);
                onContinue(completeAddress)
              }}>confirm</button>
            </div></div>
        </Modal>}
      </div>  </div>
  );
};

export default MapPicker;
